import React from 'react';
import FloStyleWomensHealth from './FloStyleWomensHealth';

export default function WomensHealth() {
  return <FloStyleWomensHealth />;
}
